import { StormcastEternals } from "whole-shared";

import type { ClientAosFaction } from "./factions";

export const ClientStormcastEternals: ClientAosFaction = { ...StormcastEternals, name: "STORMCAST ETERNALS" };
